module.exports = __webpack_public_path__ + "img/loading_black.0c8ddbf4.svg";